import React, { useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Icon,
  Tag,
  FormFooter,
  Notification
} from "xsolla-uikit";


import PAtabs from "./PAtabs";

import merge from "deepmerge";
import { ContextConsumer } from "../App";
import { IntlProvider } from "react-intl";
import PAContentBlock from "./PAContentBlock";
import { Link } from "react-router-dom";





import CardNew, {CardItem,  CardTodo, CardSite, CardFlatten } from "./PAcardNew";

import { PAchart1, PAchartMap } from "./PAcharts";
import { PAchart1fake, PAchart2 } from "./PAchart2";

export default function PAlogin() {
  const logins = [
    {
      product: 'login',
      sku: 'login_1',
      name: "Login for My Game: Ultimate Edition",
      id: "ce084f8d-89bf-11e8-ad67-d89d67155224",
      img: "https://res.cloudinary.com/maiik/image/upload/v1564043663/Xsolla_PA/temp/Frame_3.10.png",
      status: "active",
      customize: 'widget',
      button: ()=>{return <Link to="/login/my_project">
        <Button
          appearance="outline"
        >
          Edit settings
        </Button>
      </Link>},
      used: [
        {
          product:  'store',
          name: "Game keys / My Game: Ultimate Edition",
          action: "/game_keys/my_project",
          status: 'active',
        },
        {
          product:  'site_builder',
          name: "My Game",
          action: "/site_builder/my_project/",
          status: 'draft',
        },
        {
          product:  'launcher',
          name: "My Game Launcher",
          action: "/launcher/my_project/",
          status: 'draft',
        }
      ],
      todo: [
        {
          title: "Complete setting up your landing page",
          value: 0.5
        },

      ],
    },
    {
      product: 'login',
      sku: 'login_2',
      name: "test login",
      id: "ce084f8d-89bf-11e8-ad67-d89d67155224",
      customize: 'widget',
      img:
        "https://res.cloudinary.com/maiik/image/upload/v1564044678/Xsolla_PA/temp/Frame_3.16.png",
      status: "draft",
      used: [
        {
          name: "Game keys / My Game: Ultimate Edition",
          action: "/game_keys/my_project/"
        }
      ],
      todo: [
      {
        title: "Add a callback url",
        value: 0.5
      },
      ],

    },
    {
      product: 'login',
      sku: 'login_3',
      name: "test login 2",
      id: "ce084f8d-89bf-11e8-ad67-d89d67155224",
      customize: 'widget',
      img:
        "https://res.cloudinary.com/maiik/image/upload/v1564044678/Xsolla_PA/temp/Frame_3.16.png",
      status: "draft",
      used: [],
      todo: [
        {
          title: "Add a callback url",
          value: 0.5
        },
        {
          title: "Enable social networks",
          value: 0
        },
        ],
    }
  ];

  const [state, setState] = useState({
    tab: "all"
  });

  return (

      <div className="xsui-width">


        <FormGroup>
          <div className="xsui-breadcrumbs_entry">
            <div className="xsui-breadcrumbs_item">
              <Link className="xsui-breadcrumbs_label" to="/site_builder">
                <div className="xsui-typography--display">Login</div>
              </Link>
              <div className="xsui-breadcrumbs_chevron">
                <i
                  className="xsui-icon xsui-icon-chevron"
                  style={{
                    fontSize: 24,
                    color: "inherit"
                  }}
                />
              </div>
            </div>
          </div>
        </FormGroup>

        {/* MENU */}


{/* <PAtabs
  items = {[

  ]}
/> */}


        {/* <div className="ui-navigation ui-navigation--size-md ui-navigation--bordered">
        <FormGroup
          // border="xs"
          style={{ paddingBottom: 0 }}>
          <div className="ui-navigation__menu">
            <div className="ui-navigation__section">
              <div
                className={`ui-navigation__item ${
                  state.tab === "stat" ? "ui-navigation__item--active" : ""
                }`}
                onClick={() => {
                  setState({
                    ...state,
                    tab: "stat"
                  });
                }}
              >
                Login Dashboard
              </div>

              <div
                className={`ui-navigation__item ${
                  state.tab === "all" ? "ui-navigation__item--active" : ""
                }`}
                onClick={() => {
                  setState({
                    ...state,
                    tab: "all"
                  });
                }}
                // className="ui-navigation__item--active"
              >
                All Logins (5)
              </div>
            </div>
            <div className="ui-navigation__section ui-navigation__section--actions" />
          </div>
        </FormGroup>
        </div> */}

        <div className="xsui-width">
          {state.tab === "stat" && (
            <FormGroup indentation="lg">
              <CardNew  indentation="lg" wave={false}>
                <PAchart1fake />
              </CardNew>
            </FormGroup>
          )}

          {state.tab === "all" && (
            <FormGroup indentation="lg">
              <CSScards>
                {logins.map((oneLogin, ind) => {
                  return (
                    // <FormGroup indentation="lg" key={`login_${ind}`}>
                      <CardItem size="lg" {...oneLogin}  key={`login_${ind}`} />
                    // </FormGroup>
                  );
                })}
              </CSScards>
            </FormGroup>
          )}
        </div>
      </div>

  );
}


const CSScards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  grid-column-gap: 24px;
`;